/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TeacherActivity } from './teacherActivity';
import { TeacherTarget } from './teacherTarget';

export interface TeacherActivityTargetLink { 
    readonly id: string;
    readonly activity: TeacherActivity;
    readonly target: TeacherTarget;
    readonly createdAt: Date;
    isChecked?: boolean;
    readonly subtypeType: string;
}